import { ButcherHeader } from '@components/ButcherHeader';
import { SideNav } from '@components/OrderCreation/OrderSideNav';
import { OrderListBreadcrumbs } from '@components/OrderProcessing/OrderListBreadcrumbs';
import { PlansViewDetails } from '@components/Subscription/PlansViewDetails';
import { useToast } from '@contexts/Toast';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Axios } from '@helpers/ApiService';
import {
  AppSettingsSubscriptionSteps,
  butcherSubscriptionsStatus,
  errorMessage,
  OrderProcessingMasterData,
} from '@helpers/Constants';
import { ApiEndpoints } from '@helpers/Constants/Navigation';
import { Subscription } from '@helpers/Models';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const ReactivateSubscriptionDetails = () => {
  const navigate = useNavigate();
  const { showToastMessage } = useToast();

  const [subscriptionDetails, setSubscriptionDetails] =
    useState<Subscription | null>(null);

  useEffect(() => {
    fetchSubscriptionDetails();
  }, []);

  const BreadCrumbsProps = {
    steps: AppSettingsSubscriptionSteps,
    activeItem: 'Subscription',
    type: OrderProcessingMasterData.APP_SETTINGS,
  };

  /**
   * Fetches the current subscription details from the backend.
   *
   * @async
   * @function fetchSubscriptionDetails
   * @returns {Promise<void>}
   *
   * @remarks
   * - Retrieves subscription data using the API endpoint.
   * - Updates the local state with the fetched subscription details.
   * - Stores the latest subscription status in `localStorage` for global access.
   * - Displays an error toast message if the request fails.
   */
  const fetchSubscriptionDetails = async () => {
    try {
      const response = await Axios.get(
        ApiEndpoints.FETCH_BUTCHER_SUBSCRIPTION_DETAILS,
      );
      setSubscriptionDetails(response.data.data.subscription);
      localStorage.setItem(
        'subscriptionStatus',
        butcherSubscriptionsStatus.CANCELLED.toString(),
      );
    } catch (error) {
      showToastMessage(errorMessage.FETCH_ERROR, 'error');
    }
  };

  return (
    <div className="flex h-screen w-screen gap-1">
      {/* Sidebar */}
      <SideNav active={10} />
      {/* Main Content */}
      <div className="flex-1 p-1 overflow-auto relative">
        {/* Header */}
        <ButcherHeader />
        <OrderListBreadcrumbs orderInfo={BreadCrumbsProps} />

        <div className="flex items-center justify-between mt-4 mb-4">
          <div className="flex items-center">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="text-[#1C1B1F] hover:text-primary text-lg mr-2 focus:outline-none"
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>
            <h2 className="text-2xl font-semibold ml-2">
              Reactivate Subscription
            </h2>
          </div>
        </div>

        {/* Main content */}
        <PlansViewDetails
          isFromAppSettings={true}
          subId={subscriptionDetails?.id}
        />
      </div>
    </div>
  );
};
